var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.templateType === 'group')?_c('Group'):_vm._e(),_vm._v(" "),(_vm.templateType === 'manage')?_c('Manage'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }